import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import Table from "../../../../Componets/Table";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Billings/Billings/tables";
import headers from "../../../../Data/Tables/Billings/Billings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import {
  EyeOutlined,
  DollarOutlined,
  SettingOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Button, Switch } from "antd";
import OpeningBalanceModal from "../Registry/OpeningBalanceModal";
import CloseRegistryModal from "../Registry/CloseRegistryModal";
import { check_registry_status } from "../../../../Controllers/Registry";
import RegistrySessions from "../../Session/table";
import { useSearchParams } from "react-router-dom";

const BillingTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [viewMode, setViewMode] = useState("invoice");
  const [originalInvoices, setOriginalInvoices] = useState([]);
  const [closeRegistryVisible, setCloseRegistryVisible] = useState(false);
  const [openRegistryVisible, setOpenRegistryVisible] = useState(false);
  const [registryStatus, setRegistryStatus] = useState(null);
  const [showSessions, setShowSessions] = useState(false);
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    // Check if there's a page parameter in the URL
    const urlPage = searchParams.get('page');
    const initialPage = urlPage ? parseInt(urlPage) : 1;
    
    // Set the initial page from URL or default to 1
    setPagination(prev => ({
      ...prev,
      currentPage: initialPage
    }));
    
    // Fetch data with the correct page
    fetchData({ currentPage: initialPage });
    headerReset();
    checkRegistryStatus();
  }, []);

  const checkRegistryStatus = async () => {
    try {
      const response = await check_registry_status();
      if (response.status) {
        setRegistryStatus(response.data);
      }
    } catch (error) {
      console.error("Error checking registry status:", error);
    }
  };

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment,
      sort: headerdata?.sort,
      customer: headerdata?.customer,
      status: headerdata?.status,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
    });
  };

  const formdata = (data) => {
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment,
      sort: headerdata?.sort,
      customer: headerdata?.customer,
      status: headerdata?.status,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const prepareInvoiceData = (invoices, currentPage) => {
    let data = [];
    invoices?.map((value, index) => {
      data?.push({
        path: `/app/billing/view/${value?._id}?returnPage=${currentPage}`,
        Number: `#INV-${value?.number}`,
        Customer:
          value?.customer?.name && value?.customer?.phone
            ? `${value?.customer?.name} (${value?.customer?.phone})`
            : value?.customer?.name
            ? value?.customer?.name
            : value?.customer?.phone
            ? value?.customer?.phone
            : "Walk-in-customer",
        Date: moment(value?.date).format("MMMM Do YYYY"),
        Due: moment(value?.due_date).format("MMMM Do YYYY"),
        "Billed By": value?.created_by?.name,
        "Payment Type":
          value?.payments?.length > 0
            ? value.payments.map((v, i) => (
                <div className="text-xs" key={i}>
                  {v?.name} : {v?.amount?.toFixed?.(3)}
                </div>
              ))
            : "",
        Delivery:
          value?.delivery_status == 2 ? (
            <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
              Delivered
            </span>
          ) : value?.delivery_status == 1 ? (
            <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
              Partial
            </span>
          ) : (
            <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
              Pending
            </span>
          ),
        Payment:
          value?.payment_status == 2 ? (
            <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
              Paid
            </span>
          ) : value?.payment_status == 1 ? (
            <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
              Partial
            </span>
          ) : (
            <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
              Unpaid
            </span>
          ),
        Total: value?.total?.toFixed(3),
        Status: <Status status={value?.status} />,
      });
    });
    setBody(data);
  };

  const preparePaymentData = (invoices) => {
    const paymentSummary = {};
    invoices?.forEach((invoice) => {
      if (invoice.payments && invoice.payments.length > 0) {
        invoice.payments.forEach((payment) => {
          if (!paymentSummary[payment.name]) {
            paymentSummary[payment.name] = { amount: 0, count: 0 };
          }
          paymentSummary[payment.name].amount += payment.amount;
          paymentSummary[payment.name].count += 1;
        });
      } else {
        const noPaymentType = "No Payment";
        if (!paymentSummary[noPaymentType]) {
          paymentSummary[noPaymentType] = { amount: 0, count: 0 };
        }
        paymentSummary[noPaymentType].amount += invoice.total;
        paymentSummary[noPaymentType].count += 1;
      }
    });

    const data = Object.entries(paymentSummary).map(([paymentType, data]) => ({
      "Payment Mode": paymentType,
      "Total Amount": data.amount.toFixed(3),
      "Transaction Count": data.count,
      Action: (
        <Button type="link" onClick={() => showPaymentDetails(paymentType)}>
          View Details
        </Button>
      ),
    }));

    setBody(data);
  };

  const fetchData = async (tabledata = {}) => {
    try {
      setLoader(true);
      const data = {
        search: tabledata?.search,
        payment: tabledata?.payment,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.currentPage || pagination.currentPage,
        excludeClosed: registryStatus?.isOpen,
      };

      const invoices = await get_all_invoices(data);

      if (invoices?.status) {
        const invoicesData = invoices?.data?.data || [];
        const currentPage = invoices?.data?.currentPage || 1;
        
        setOriginalInvoices(invoicesData);

        // Update pagination first
        setPagination({
          currentPage: currentPage,
          totalCount: invoices?.data?.totalCount,
          totalPages: invoices?.data?.totalPages,
        });

        // Then prepare data with the current page
        if (viewMode === "invoice") {
          prepareInvoiceData(invoicesData, currentPage);
        } else {
          preparePaymentData(invoicesData);
        }

        setLoader(false);
      } else {
        toast?.error(invoices?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const showPaymentDetails = (paymentType) => {
    const filteredInvoices = originalInvoices.filter((invoice) => {
      if (paymentType === "No Payment") {
        return !invoice.payments || invoice.payments.length === 0;
      }
      return (
        invoice.payments && invoice.payments.some((p) => p.name === paymentType)
      );
    });

    prepareInvoiceData(filteredInvoices, pagination.currentPage);
    setViewMode("invoice");
  };

  const toggleViewMode = () => {
    const newViewMode = viewMode === "invoice" ? "payment" : "invoice";
    setViewMode(newViewMode);

    if (newViewMode === "invoice") {
      prepareInvoiceData(originalInvoices, pagination.currentPage);
    } else {
      preparePaymentData(originalInvoices);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({ ...value, value: null });
    });
    setHeader({ ...headers, components: componentData });
  };

  const handleRegistryClosed = () => {
    checkRegistryStatus();
    fetchData();
  };

  const handleShowSessions = () => {
    setShowSessions(true);
  };

  const handleBackToInvoices = () => {
    setShowSessions(false);
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <div className="flex justify-between items-center mb-4 mt-4 m-2">
        <div className="flex items-center">
          <Switch
            checked={viewMode === "payment"}
            onChange={toggleViewMode}
            checkedChildren={<DollarOutlined />}
            unCheckedChildren={<EyeOutlined />}
          />
          <span className="ml-2">
            {viewMode === "invoice" ? "Invoice View" : "Payment Summary View"}
          </span>
        </div>

        <div className="flex items-center">
          <Button
            type="primary"
            onClick={() => setOpenRegistryVisible(true)}
            disabled={registryStatus?.isOpen}
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]  
              disabled:!bg-[#a6e8c5] disabled:!border-[#a6e8c5] disabled:!text-black disabled:opacity-70"
          >
            Open Registry
          </Button>
          <OpeningBalanceModal
            visible={openRegistryVisible}
            onClose={() => setOpenRegistryVisible(false)}
            onRefetch={checkRegistryStatus}
          />

          <Button
            type="primary"
            icon={<SettingOutlined />}
            onClick={() => setCloseRegistryVisible(true)}
            disabled={!registryStatus?.isOpen}
            className="mr-2 
              !bg-[#07b553] !border-[#07b553] 
              hover:!bg-[#38cb82] hover:!border-[#38cb82]
              disabled:!bg-[#a6e8c5] disabled:!border-[#a6e8c5] disabled:!text-black disabled:opacity-70"
          >
            Close Registry
          </Button>
          <CloseRegistryModal
            visible={closeRegistryVisible}
            onClose={() => setCloseRegistryVisible(false)}
            onRegistryClosed={handleRegistryClosed}
            openingBalance={registryStatus?.registry?.openingBalance || 0}
          />
        </div>
      </div>
      <Loadercomponent loader={loader}>
        <Table
          head={
            viewMode === "invoice"
              ? tables
              : [
                  { name: "Payment Mode", value: "Payment Mode" },
                  { name: "Total Amount", value: "Total Amount" },
                  { name: "Transaction Count", value: "Transaction Count" },
                  { name: "Action", value: "Action" },
                ]
          }
          body={body}
          pagination={viewMode === "invoice" ? pagination : null}
          paginationdata={viewMode === "invoice" ? paginationdata : null}
        />
      </Loadercomponent>
    </Header>
  );
};

export default BillingTable;